import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, BarChart3, Brain, ClipboardList, GraduationCap, Users } from "lucide-react";

const ITEMS = [
  {
    to: "/iq",
    external: false,
    icon: Brain,
    badge: "Sabke liye — free",
    title: "IQ & Brain Challenge",
    desc: "Class 1 se senior citizens tak — age-smart reasoning puzzles, sound effects, Hindi/English. Login nahi chahiye.",
    cta: "Challenge khelen",
    tid: "home-iq-cta",
    ring: "hover:border-sky-500/60",
    iconCls: "bg-sky-500/15 text-sky-400",
  },
  {
    to: "/survey",
    external: false,
    icon: ClipboardList,
    badge: "Students ke liye",
    title: "Student Learning Survey",
    desc: "3–4 minute ka survey — aapki zaroorat bataiye, hum wahi courses banayen. Naam/phone optional.",
    cta: "Survey dein",
    tid: "home-survey-cta",
    ring: "hover:border-amber-500/60",
    iconCls: "bg-amber-500/15 text-amber-400",
  },
  {
    to: "/crm",
    external: false,
    icon: BarChart3,
    badge: "Institute owners ke liye",
    title: "VOOGLY CRM",
    desc: "Leads se fees tak — coaching/institute ka poora hisaab ek dashboard par. Multi-tenant SaaS.",
    cta: "CRM kholen",
    tid: "home-crm-cta",
    ring: "hover:border-emerald-500/60",
    iconCls: "bg-emerald-500/15 text-emerald-400",
  },
];

export default function PlatformSection() {
  return (
    <section className="relative py-20" data-testid="platform-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.5 }}>
          <p className="flex items-center gap-2 font-mono text-[10px] font-bold uppercase tracking-[0.22em] text-amber-400">
            <GraduationCap size={13} /> VOOGLY Platform
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-white sm:text-4xl">Sirf courses nahi — poora ecosystem</h2>
          <p className="mt-2 max-w-2xl text-sm text-slate-400">Students apni zaroorat batate hain, institutes apna hisaab sambhalte hain — sab VOOGLY ke saath.</p>
        </motion.div>
        <div className="mt-10 grid gap-5 lg:grid-cols-3">
          {ITEMS.map((it, i) => (
            <motion.div key={it.title} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.5, delay: i * 0.12 }}>
              {it.external ? (
                <a href={it.to} target="_blank" rel="noreferrer" data-testid={it.tid} className={`flex h-full flex-col justify-between rounded-3xl border border-white/10 bg-ink2 p-7 transition-all ${it.ring}`}>
                  <Card it={it} />
                </a>
              ) : (
                <Link to={it.to} data-testid={it.tid} className={`flex h-full flex-col justify-between rounded-3xl border border-white/10 bg-ink2 p-7 transition-all ${it.ring}`}>
                  <Card it={it} />
                </Link>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Card({ it }) {
  return (
    <>
      <div>
        <div className="flex items-center gap-3">
          <span className={`flex h-11 w-11 items-center justify-center rounded-2xl ${it.iconCls}`}><it.icon size={20} /></span>
          <span className="rounded-full border border-white/10 px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-wider text-slate-400">{it.badge}</span>
        </div>
        <h3 className="mt-4 font-display text-2xl font-black text-white">{it.title}</h3>
        <p className="mt-2 text-sm leading-relaxed text-slate-400">{it.desc}</p>
      </div>
      <span className="mt-6 inline-flex items-center gap-2 text-sm font-black text-amber-400">
        {it.cta} <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
      </span>
    </>
  );
}
